<template>
	<el-row :gutter="20">
	    <el-col :span="4">
			<el-input
				v-model="filterText"
				class="w-60 mb-2"
				placeholder="搜索关键词"
			/>
			<el-tree
				ref="treeRef"
				style="max-width: 600px;margin-top: 10px;"
				class="filter-tree"
				:data="data"
				:props="defaultProps"
				default-expand-all
				highlight-current
				:filter-node-method="filterNode"
				@node-click="handleNodeClick"
			/>
		</el-col>
	    <el-col :span="20">
			<div style="right: 20px;position: absolute;top: -12px;z-index: 999;">
				<el-button type="primary" round @click="addDepartment()">添加部门</el-button>
				<el-button type="primary" round @click="addUser()">添加人员</el-button>
			</div>
			<el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
			    <el-tab-pane label="部门信息" name="first">
					<div v-if="!!currentDep.id" style="margin-left: 2%;">
					    <span>
					      名称 : {{currentDep.departmentname}}
					    </span>
					    <el-divider />
					    <span>
					      简称 : {{currentDep.departmentdesc}}
					    </span>
						<el-divider />
						<span>
						  排序 : {{currentDep.px}}
						</span>
						<el-divider />
						<el-button type="primary" round @click="modifyDepartment()">编辑</el-button>
					  </div>
				</el-tab-pane>
			    <el-tab-pane label="人力资源" name="second">
					<el-table :data="tableData" style="width: 100%" height="680">
					    <el-table-column fixed prop="username" label="账号" width="320" />
					    <el-table-column prop="nickname" label="名称" width="300" />
						<el-table-column prop="tenant_key" label="租户编号" width="320" />
						<el-table-column prop="statusSpan" label="状态" width="320" >
							<template #default="scope">
								<el-tag :type="scope.row.statusSpan === '在职' ? 'primary' : 'success'" disable-transitions>{{ scope.row.statusSpan }}</el-tag>
							</template>
						</el-table-column>
					    <el-table-column fixed="right" label="操作" width="*">
					      <template #default="scope">
							<el-button v-if="scope.row.status===0" link type="primary" size="small" @click="fireData(scope.row)">离职</el-button>
							<el-button v-if="scope.row.status===1" link type="primary" size="small" @click="hireData(scope.row)">返聘</el-button>
							<el-button v-if="scope.row.status===0" link type="primary" size="small" @click="modifyName(scope.row)">编辑</el-button>
					      </template>
					    </el-table-column>
					</el-table>
					<div class="pagination-custom">
						<el-pagination :page-size="hrmPageSize" @current-change="changePageNo" background layout="pager" :total="total" />
					</div>
				</el-tab-pane>
			  </el-tabs>
		</el-col>
	</el-row>
	<el-dialog
	    v-model="depDialogVisible"
	    title="新增/编辑部门"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>
		<el-form
		    ref="ruleFormRef"
		    :model="sizeForm"
		    label-width="auto"
		    :label-position="labelPosition"
		    :size="size"
		>
			<div style="display: flex;">
				<el-form-item label="部门简称" style="width: 96%;" >
				  <el-input v-model="sizeForm.departmentdesc" class="w-50 m-2" placeholder="请输入部门简称" />
				</el-form-item>
			</div>
			<div style="display: flex;">
				<el-form-item label="部门全称" style="width: 96%;" >
				  <el-input v-model="sizeForm.departmentname" class="w-50 m-2" placeholder="请输入部门全称" />
				</el-form-item>
			</div>
			<div style="display: flex;">
				<el-form-item label="排序" style="width: 96%;" >
				  <el-input-number v-model="sizeForm.px" class="w-50 m-2" :step="1"/>
				</el-form-item>
			</div>
		</el-form>
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="depDialogVisible = false">关闭</el-button>
		    <el-button type="primary" @click="saveDepartment">保存</el-button>
		  </span>
		</template>
	</el-dialog>
	<el-dialog
	    v-model="bzDialogVisible"
	    title="编辑"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>
		<el-input class="w-50 m-2" v-model="newNickName" />
		<el-divider />
		<label>选择所属部门 : </label><el-select
		  v-model="newDepartmentid"
		  collapse-tags
		  placeholder="选择所属部门"
		  style="width: 360px"
		>
		  <el-option
			v-for="item in departmentInfos"
			:key="item.value"
			:label="item.label"
			:value="item.value"
		  />
		</el-select>
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="bzDialogVisible = false">关闭</el-button>
		    <el-button type="primary" @click="saveNickName">保存</el-button>
		  </span>
		</template>
	</el-dialog>
</template>

<script setup>
	import { ref,watch,onMounted } from 'vue';
	import axios from 'axios';
	import { useMemberStore } from '../../stores';
	import { ElMessage } from 'element-plus'
	import { useRouter } from 'vue-router'
	const router = useRouter();
	const userStore = useMemberStore();
	const bzDialogVisible = ref(false)
	const newNickName = ref('')
	const modifyName = async(e) =>{
		billid.value = e.id
		newNickName.value = e.nickname
		newDepartmentid.value = e.departmentid
		bzDialogVisible.value = true
	}
	const newDepartmentid = ref('')
	const saveNickName = async() =>{
		const response = await axios.post('/hrm/user/modifyNickName', {
		  billid:billid.value,
		  nickname:newNickName.value,
		  departmentid:newDepartmentid.value
		}, {
		  headers: {
			'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage.success('修改成功!')
			bzDialogVisible.value = false
			fetchHrmResource()
		}
	}
	const modifyDepartment =()=>{
		depDialogVisible.value = true;
		sizeForm.value.departmentname = currentDep.value.departmentname
		sizeForm.value.departmentdesc = currentDep.value.departmentdesc
		sizeForm.value.px = currentDep.value.px
		billid.value = currentDep.value.id
	}
	const fireData = async(e)=>{
		const response = await axios.post('/hrm/user/modifyStatus', {
		  billid:e.id,
		  status:1
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage({
				message: '离职成功!',
				type: 'success',
			})
			fetchHrmResource()
		}
	}
	const hireData = async(e) =>{
		const response = await axios.post('/hrm/user/modifyStatus', {
		  billid:e.id,
		  status:0
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage({
				message: '返聘成功!',
				type: 'success',
			})
			fetchHrmResource()
		}
	}
	const activeName = ref('first')
	const size = ref('default')
	const labelPosition = ref('right')
	const depDialogVisible = ref(false)
	const sizeForm = ref({
		departmentname:'',
		departmentdesc:'',
		px:0,
	});
	const handleNodeClick=(node)=>{
		activeName.value = 'first';
		currentDep.value = {}
		originalData.value.map(item=>{
			if(item.id===node.id){
				currentDep.value = item
			}
		})
	}
	const addDepartment = () =>{
		depDialogVisible.value = true;
	}
	const billid = ref('')
	const departmentInfos = ref([])
	const saveDepartment = async() =>{
		const response = await axios.post('/hrm/department/add', {
		  ...sizeForm.value,
		  billid:billid.value
		}, {
		  headers: {
			'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			billid.value = ''
			ElMessage.success('保存成功!')
			depDialogVisible.value = false
			currentDep.value = {}
			sizeForm.value = {}
			fetchOrders()
		}else{
			ElMessage.error(response.data.msg)
		}
	}
	const tableData = ref([]);
	const hrmPageNo = ref(1);
	const hrmPageSize = ref(20);
	const total = ref(0);
	const changePageNo = (val) => {
		hrmPageNo.value = val;
		fetchHrmResource();
	}
	const fetchHrmResource = async() =>{
		const response = await axios.post('/hrm/user/queryListByDep', {
		  pageNo:hrmPageNo.value,
		  pageSize:hrmPageSize.value,
		  departmentId:currentDep.value?.id
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = response.data.data;
			total.value = response.data.total;
		}
	}
	const addUser=()=>{
		router.push('/hrm/user-add'); 
	}
	const currentDep = ref({})
	const handleClick = (tab, event) => {
		if(activeName.value==='second'){
			fetchHrmResource()
		}
	}
	const filterText = ref('')
	const treeRef = ref(null)
	const defaultProps = {
	  children: 'children',
	  label: 'label',
	}
	const pageNo = ref(1);
	const pageSize = ref(50);
	onMounted(async()=>{
		fetchOrders()
	})
	const originalData = ref([])
	const fetchOrders = async () => {
		const response = await axios.post('/hrm/department/queryList', {
		  pageNo:pageNo.value,
		  pageSize:pageSize.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			originalData.value = response.data.data
			const treeData = [];
			response.data.data.map(item=>{
				treeData.push({
					id:item.id,
					label:item.departmentname,
					children:[]
				})
				departmentInfos.value.push({
					label:item.departmentname,
					value:item.id
				})
			})
			data.value = treeData
		}
	};
	watch(filterText, (val) => {
	  if(treeRef.value){
		treeRef.value?.filter(val)
	  }
	})
	
	const filterNode = (value, data) => {
	  if (!value) return true
	  return data.label.includes(value)
	}
	const data = ref([])
</script>

<style scoped>
	.pagination-custom{
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin: 10px 0;
	}
	.el-tree-node{
		padding: 4px 0;
		font-size: 16px;
	}
</style>